import goldenWinter from "../img/compozitii-de-iarna/1golden-winter.webp";
import frostenPine from "../img/compozitii-de-iarna/2frosted-pine.webp";
import hollyBerry from "../img/compozitii-de-iarna/3holly-berry.webp";
import icicleDream from "../img/compozitii-de-iarna/4icicle-dream.webp";
import velvetWinter from "../img/compozitii-de-iarna/5velvet-winter.webp";
import winterBloom from "../img/compozitii-de-iarna/6winter-bloom.webp";
import redExplosion from "../img/compozitii-de-iarna/7red-explosion.webp";
import icyBliss from "../img/compozitii-de-iarna/8icy-bliss.webp";
import winterBouquet from "../img/compozitii-de-iarna/9winter-bouquet.webp";
import everGreen from "../img/compozitii-de-iarna/10evergreen.webp";
import littleWinter from "../img/compozitii-de-iarna/11little-winter.webp";
import winterElegance from "../img/compozitii-de-iarna/12winter-elegance.webp";
import winterCharm from "../img/compozitii-de-iarna/13winter-charm.webp";
import tableDecor from "../img/compozitii-de-iarna/14table-decor.webp";
import winterDeluxe from "../img/compozitii-de-iarna/15winter-deluxe.webp";

//1001-1050
const compozitiiDeIarna = [
  {
    id: 1001,
    name: "Golden Winter",
    price: "1300 lei",
    description:
      "Brad cu inaltime de 40 cm, decorat in coloristica aurie.",
    images: [goldenWinter],
  },
  {
    id: 1002,
    name: "Frosted Pine",
    price: "1300 lei",
    description:
      "Brad cu inaltime de 40 cm, decorat in nuante de albastru si roz. ",
    images: [frostenPine],
  },
  {
    id: 1003,
    name: "Holly Berry",
    price: "1200 lei",
    description:
      "Brad cu inaltime de 40 cm, decorat in coloristica rosie.",
    images: [hollyBerry],
  },

  {
    id: 1004,
    name: "Icicle Dream",
    price: "600 lei",
    description:
      "Compozitie in culori calde.",
    images: [icicleDream],
  },
  {
    id: 1005,
    name: "Velvet Winter",
    price: "1000 lei",
    description:
      "Brad cu inaltime de 40 cm, decorat in coloristica rosie.",
    images: [velvetWinter],
  },
  {
    id: 1006,
    name: "Winter Bloom",
    price: "1500 lei",
    description: "Cutie decorata cu mix de crengi de brad si pin, in nuante de alb-auriu.",
    images: [winterBloom],
  },
  {
    id: 1007,
    name: "Red Explosion",
    price: "1000 lei",
    description:
      "Compozitie din brad in nuante rosu-auriu.",
    images: [redExplosion],
  },
  {
    id: 1008,
    name: "Icy Bliss",
    price: "1300 lei",
    description:
      "Compozitie in culori pastelate roz-auriu.",
    images: [icyBliss],
  },
  {
    id: 1009,
    name: "Winter Bouquet",
    price: "700 lei",
    description:
      "BUchet format dintr-un mix de crengi de brad, ilex si eucalipt stabilizat.",
    images: [winterBouquet],
  },
  {
    id: 1010,
    name: "Evergreen",
    price: "1000 lei",
    description:
      "Compozitie dintr-un mix de crengi de brad si pin in nuante verde-auriu.",
    images: [everGreen],
  },
  {
    id: 1011,
    name: "Little Winter",
    price: "450 lei",
    description:
      "Mini compozitie din brad cu decoratiuni de culoare rosie si bumbac.",
    images: [littleWinter],
  },
  {
    id: 1012,
    name: "Winter Elegance",
    price: "1100 lei",
    description:
      "Cutie formata din mix de crengi de brad si pin, decorata cu bumbac si accesorii rosii.",
    images: [winterElegance],
  },
  {
    id: 1013,
    name: "Winter Charm",
    price: "1400 lei",
    description:
      "Cutie de Craciun decorata cu bumbac, crengi decorative si accesorii rosii.",
    images: [winterCharm],
  },
  {
    id: 1014,
    name: "Table Decor",
    price: "1400 lei",
    description:
      "Decoratiune de masa cu aspect luxuriant, formata din decoratiuni de culoare verde, aurii si candelabre.",
    images: [tableDecor],
  },
  {
    id: 1015,
    name: "Winter Deluxe",
    price: "1400 lei",
    description:
      "Decoratiune cu lungimea de 70 cm formata dintr-un mix de crengi de brad, ilex si decoratiuni rosii.",
    images: [winterDeluxe],
  },
];

export default compozitiiDeIarna;
